var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderPlacedStepper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H3C1.59375 0.5 0.5 1.63281 0.5 3V18C0.5 19.4062 1.59375 20.5 3 20.5H13C14.3672 20.5 15.5 19.4062 15.5 18V3C15.5 1.63281 14.3672 0.5 13 0.5ZM8.625 14.25H3.625C3.27344 14.25 3 13.9766 3 13.625C3 13.3125 3.27344 13 3.625 13H8.625C8.9375 13 9.25 13.3125 9.25 13.625C9.25 13.9766 8.9375 14.25 8.625 14.25ZM12.375 10.5H3.625C3.27344 10.5 3 10.2266 3 9.875C3 9.5625 3.27344 9.25 3.625 9.25H12.375C12.6875 9.25 13 9.5625 13 9.875C13 10.2266 12.6875 10.5 12.375 10.5ZM12.375 6.75H3.625C3.27344 6.75 3 6.47656 3 6.125C3 5.8125 3.27344 5.5 3.625 5.5H12.375C12.6875 5.5 13 5.8125 13 6.125C13 6.47656 12.6875 6.75 12.375 6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlacedStepper);
export default __webpack_public_path__ + "static/media/order-placed-stepper.065e4a7e004b6e8616485462da55c679.svg";
export { ForwardRef as ReactComponent };